import { useEffect } from 'react'

import { setExperiments } from '@/lib/attribution/experimentAssignments'

import { useOptimizelyFlagsInfo } from './useOptimizelyFlagsInfo'

/**
 * Mirrors the Optimizely experiment→variation assignments into the in-memory
 * store so the attribution lead-capture/purchase calls can attach them.
 */
export const useExperimentAssignmentsCapture = () => {
  const { assignments } = useOptimizelyFlagsInfo()

  useEffect(() => {
    setExperiments(assignments)
  }, [assignments])
}
